import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// We no longer need HelmetProvider
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* The HelmetProvider is gone */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);